"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthYearPicker = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const radiobutton_1 = require("primereact/radiobutton");
const calendar_1 = require("primereact/calendar");
const useIsMobile_1 = require("../../hooks/mobile/useIsMobile");
const react_i18next_1 = require("react-i18next");
const MonthYearPicker = ({ value, onChange, onlyMonth, }) => {
    const isMobile = (0, useIsMobile_1.useIsMobile)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const [mode, setMode] = (0, react_1.useState)(onlyMonth || value?.month ? 'month-year' : 'year');
    const calendarRef = (0, react_1.useRef)(null);
    const [internalValue, setInternalValue] = (0, react_1.useState)(null);
    // Sincronizar el valor interno con las props
    (0, react_1.useEffect)(() => {
        if (value?.year) {
            const year = Number(value.year);
            const month = value.month ? Number(value.month) - 1 : 0;
            if (!isNaN(year)) {
                setInternalValue(new Date(year, month, 1));
            }
        }
        else {
            setInternalValue(null);
        }
    }, [value]);
    // Efecto para manejar el input del Calendar
    (0, react_1.useEffect)(() => {
        if (calendarRef.current) {
            const input = calendarRef.current.getInput();
            const handleKeyDown = (e) => {
                // Permitir navegación, borrado y comandos especiales
                if ([
                    'ArrowLeft',
                    'ArrowRight',
                    'Delete',
                    'Backspace',
                    'Tab',
                    'Home',
                    'End',
                ].includes(e.key) ||
                    (e.ctrlKey && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase()))) {
                    return;
                }
                // Prevenir entrada no numérica
                if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                    return;
                }
                if (mode === 'month-year') {
                    const cursorPos = input.selectionStart || 0;
                    const value = input.value;
                    // Manejar autocompletado de la barra
                    if (cursorPos === 2 && value.length === 2 && e.key !== '/') {
                        input.value = value + '/' + e.key;
                        e.preventDefault();
                        setTimeout(() => {
                            input.setSelectionRange(4, 4);
                        }, 0);
                    }
                    // Limitar a 7 caracteres (MM/YYYY)
                    if (value.length >= 7 && cursorPos >= 7) {
                        e.preventDefault();
                    }
                }
                else {
                    // Modo año - limitar a 4 dígitos
                    const value = input.value;
                    if (value.length >= 4) {
                        e.preventDefault();
                    }
                }
            };
            input.addEventListener('keydown', handleKeyDown);
            if (mode === 'month-year') {
                input.setAttribute('maxLength', '7');
                input.setAttribute('placeholder', t('monthYear'));
            }
            else {
                input.setAttribute('maxLength', '4');
                input.setAttribute('placeholder', t('year'));
            }
            return () => {
                input.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [mode, value?.year, t]);
    const padMonth = (month) => {
        return month < 10 ? `0${month}` : `${month}`;
    };
    const handleChange = (e) => {
        const date = e.value;
        if (date) {
            const month = mode === 'month-year' ? padMonth(date.getMonth() + 1) : '';
            const year = date.getFullYear();
            onChange({ year, month });
            setInternalValue(date);
        }
        else {
            // Solo limpiar si realmente se quiere resetear el valor
            onChange({ year: '', month: '' });
            setInternalValue(null);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "w-full card flex gap-2 justify-between items-center p-fluid", children: [!onlyMonth && ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-4 mb-1", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(radiobutton_1.RadioButton, { inputId: "year", name: "mode", value: "year", className: 'customRadio', onChange: (e) => {
                                    setMode('year');
                                    onChange({
                                        year: value?.year || new Date().getFullYear(),
                                        month: '', // Limpiamos el mes en modo año
                                    });
                                }, checked: mode === 'year' }), (0, jsx_runtime_1.jsx)("label", { className: 'text-xs', htmlFor: "year", children: t('year') })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(radiobutton_1.RadioButton, { inputId: "month-year", name: "mode", className: 'customRadio', value: "month-year", onChange: (e) => {
                                    setMode('month-year');
                                    onChange({
                                        year: value?.year || '',
                                        month: new Date().getMonth() + 1,
                                    });
                                }, checked: mode === 'month-year' }), (0, jsx_runtime_1.jsx)("label", { className: 'text-xs', htmlFor: "month-year", children: t('month') })] })] })), (0, jsx_runtime_1.jsx)(calendar_1.Calendar, { ref: calendarRef, value: internalValue, onChange: handleChange, view: mode === 'year' ? 'year' : 'month', dateFormat: mode === 'year' ? 'yy' : 'mm/yy', showIcon: true, touchUI: isMobile, readOnlyInput: isMobile, placeholder: mode === 'year' ? t('year') : t('monthYear'), className: `${onlyMonth ? 'w-full' : 'w-auto'} customDateTimePicker ${isMobile ? 'mobile-calendar' : ''}`, inputStyle: {
                    fontSize: '1rem',
                    paddingLeft: isMobile ? '0.5rem' : '',
                    border: '',
                    width: mode === 'year' ? '70px' : '100px',
                }, style: {
                    fontSize: '1rem',
                    height: isMobile ? 'auto' : '1.5rem',
                } }, mode)] }));
};
exports.MonthYearPicker = MonthYearPicker;
